export class Moreless {
  constructor(block) {
    this._block = block;
    this._content = block.querySelector('[data-moreless-content]');
    this._btn = block.querySelector('[data-moreless-btn]');
    this._btnText = block.querySelector('[data-moreless-btn-text]');

    this._limit = Number(block.dataset.morelessItems) || 3;
    this._originalText = this._btnText?.textContent || '';

    this._collapsedHeight = 0;
    this._isOpen = false;
    this._resizeTimeout = null;

    this._windowResizeHandler = this._windowResizeHandler.bind(this);
    this._toggle = this._toggle.bind(this);
  }

  init() {
    if (!this._content || !this._btn || !this._btnText) {
      return;
    }

    this._update();

    this._btn.addEventListener('click', this._toggle);
    window.addEventListener('resize', this._windowResizeHandler);

    document.fonts?.ready?.then(() => {
      this._update();
    });
  }

  _getItems() {
    return Array.from(this._content.children).flatMap((el) =>
      el.tagName === 'UL'
        ? Array.from(el.querySelectorAll('li'))
        : [el]
    );
  }

  _calcCollapsedHeight() {
    const items = this._getItems();

    if (!items.length) {
      this._collapsedHeight = 0;
      return;
    }

    if (items.length <= this._limit) {
      this._collapsedHeight = this._content.scrollHeight;
      return;
    }

    const lastVisibleItem = items[this._limit - 1];

    const contentRect = this._content.getBoundingClientRect();
    const itemRect = lastVisibleItem.getBoundingClientRect();

    const styles = getComputedStyle(lastVisibleItem);

    this._collapsedHeight =
      itemRect.bottom -
      contentRect.top +
      parseFloat(styles.marginBottom);
  }

  _update() {
    const items = this._getItems();

    if (items.length <= this._limit) {
      this._btn.hidden = true;
      this._content.style.maxHeight = 'none';
      this._isOpen = false;
      this._btn.classList.remove('is-active');
      this._btnText.textContent = this._originalText;
      return;
    }

    this._btn.hidden = false;

    this._calcCollapsedHeight();

    if (this._isOpen) {
      this._content.style.maxHeight = `${this._content.scrollHeight}px`;
    } else {
      this._content.style.maxHeight = `${this._collapsedHeight}px`;
    }
  }

  _toggle(evt) {
    evt.preventDefault();

    this._isOpen = !this._isOpen;

    if (this._isOpen) {
      this._content.style.maxHeight = `${this._content.scrollHeight}px`;
      this._btnText.textContent = 'Свернуть';
    } else {
      this._content.style.maxHeight = `${this._collapsedHeight}px`;
      this._btnText.textContent = this._originalText;
    }

    this._btn.classList.toggle('is-active', this._isOpen);
  }

  _windowResizeHandler() {
    clearTimeout(this._resizeTimeout);

    this._resizeTimeout = setTimeout(() => {
      this._update();
    }, 100);
  }
}